import type { ClientTab } from "./clientTabs";

/* W21 (B) — THE PHONE'S TAB STRIP, IN THE APP'S WORDS.
 *
 * The app's own strip is **Training · Results · About** (`ClientDetailView.Tab`, three cases, read in
 * the source rather than off a screenshot). Until W72 step 2 the web had SEVEN tabs, so `About` was a
 * group holding four of them as rows, with a `‹ About` row back out.
 *
 * 🔴 W72 STEP 2 (2026-09-25): THE WEB HAS THREE TABS NOW — Week · Progress · Profile — and they are the
 * app's three, one for one: Training is the week, Results is how it is going, About is who this is. So
 * the group, its rows and its back row are gone; the strip is the page's own three tabs in the app's
 * words, and every panel keeps its address (`clientTabs.LEGACY_TAB` maps the retired words).
 *
 * ⚠️ EXHAUSTIVE OVER `ClientTab`: a tab added to the union must be NAMED here before it compiles.
 */

/** The three controls the phone's strip paints, in the app's order. */
export const PHONE_STRIP: readonly PhoneGroup[] = ["training", "results", "about"] as const;

export type PhoneGroup = "training" | "results" | "about";

export const PHONE_GROUP_LABEL: Record<PhoneGroup, string> = {
  training: "Training",
  results: "Results",
  about: "About",
};

/** Which phone control a tab lights — one for one since W72 step 2. */
export function phoneGroup(tab: ClientTab): PhoneGroup {
  switch (tab) {
    case "week":
      return "training";
    case "progress":
      return "results";
    case "profile":
      return "about";
  }
}

/** The tab a phone control opens. */
export function tabForGroup(group: PhoneGroup): ClientTab {
  switch (group) {
    case "training":
      return "week";
    case "results":
      return "progress";
    case "about":
      return "profile";
  }
}
